<div class="questionnaire-grade-wrap">
  <ul class="questionnaire-grade-score" id="starWrap">
    <li *ngFor="let item of questionnaireScoreArray;let i = index" class="fa fa-star star-{{i}}" (click)="giveMark(i)"></li>
  </ul>
</div>



// WEBPACK FOOTER //
// ./src/component/questionnire/child-grade/component.questionnaire-grade.html